import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './service/auth.service';
import { ApiService } from './service/api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private apiService: ApiService, private router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const t = next.params;
    if ('refreshToken' in next.queryParams) {
      this.authService.signWithRefreshToken(
        next.params.businessprofileid,
        next.params.userid,
        next.queryParams.refreshToken).then((success) => {
          if (!success) {
            return Promise.resolve(false);
          } else {
            return this.authService.isAuthenticated();
          }
        }).then((authenticated) => {
          if (!authenticated) {
            this.router.navigate(['/sign-in']);
          } else {
            if ('deviceName' in next.queryParams) {
              this.router.navigate(['/device'], { queryParams: { deviceName: next.queryParams.deviceName }});
            } else if ('deviceIdentifier' in next.queryParams) {
              this.router.navigate(['/device'], { queryParams: { deviceIdentifier: next.queryParams.deviceIdentifier }});
            } else {
              this.router.navigate(['/device']);
            }
          }
          this.apiService.account().subscribe((account) => {
            const businessProfile = account.businessProfiles.find(bp => bp.id === next.params.businessprofileid);
            if (businessProfile !== null) {
              this.authService.selectBusinessProfile(businessProfile);
            }
          });
          return authenticated;
        });
    } else {
      return this.authService.isAuthenticated().then(authenticated => {
        if (!authenticated) {
          this.router.navigate(['/sign-in']);
        }
        this.apiService.account().subscribe();
        return authenticated;
      });
    }
  }
}
